export default __webpack_public_path__ + "static/media/Group8888.a5e5a042.svg";